const ShService = () =>
  import('@/views/main/helper/shService/SHService.vue')
export default {
  path: '/main/helper/shService',
  name: 'ShService',
  component: ShService,
  children: []
}
